const transformKeywords = (keywords = '') => keywords
  .split(/\s*,\s*/).filter(Boolean);

export default transformKeywords;
